import $ from 'jquery'

export default class updateBasketIcon {
    constructor (element) {
        // element is not nesessary...
        this.$element = $(element)
        this.location = this.$element.data('location')
        this.$basketButtons = $('header .basketButton')
        this.updateBasketIcons()
    }

    updateBasketIcons () {
        $.ajax({
            url: this.location,
            method: 'get',
            cache: false,
            dataType: 'html'
        }).done(this.handleRequestDone.bind(this))
    }

    handleRequestDone (data, textStatus, jqXHR) {
        this.handleResponse(jqXHR.status, data, jqXHR.responseText)
    }

    handleResponse (status, responseData, rawData) {
        if (status === 200) {
            this.$basketButtons.html(responseData)
        }
    }
}
